import { createSelector } from 'reselect'
import FetchAuthenticatorStatus from '../constants/fetch-authenticators'
import Fetch from '../constants/fetch-migrate'
import QRCodeStatus from '../constants/fetch-qr-code-status'
import FetchUserAppsStatus from '../constants/fetch-user-apps'
import SubmitPasswordTypes from '../constants/password'
import { ENROLL_MFA,
    ENROLL_MFA_ERROR,
    ENROLL_MFA_SUCCESS,
    FETCH_DATA_ERROR,
    FETCH_DATA_SUCCESS,
    SESSION_TIMEOUT,
    INIT,
    INIT_AUTHENTICATORS,
    INIT_AUTHENTICATORS_ERROR,
    INIT_AUTHENTICATORS_SUCCESS,
    INIT_ENROLL_FACTOR,
    INIT_ENROLL_FACTOR_ERROR,
    INIT_ENROLL_FACTOR_SUCCESS,
    INIT_SEND_CHALLENGE,
    INIT_SEND_CHALLENGE_SUCCESS,
    INIT_SEND_CHALLENGE_ERROR,
    INIT_USER_APPS,
    INIT_USER_APPS_ERROR,
    INIT_USER_APPS_SUCCESS,
    ON_BACK,
    ON_BACK_TWO_STEPS,
    ON_NEXT,
    ON_BACK_AUTHENTICATORS,
    ON_FINISH,
    ON_WELCOME_NEXT,
    QR_CODE_CANNOT_SCAN,
    QR_CODE_CANNOT_SCAN_NEXT,
    QR_CODE_NEXT,
    RESEND_CODE,
    RESEND_CODE_ERROR,
    RESEND_CODE_SUCCESS,
    SET_AUTHENTICATOR,
    SET_DEVICE_TYPE,
    SUBMIT_PASSWORD,
    SUBMIT_PASSWORD_ERROR,
    SUBMIT_PASSWORD_SUCCESS,
    SUBMIT_VERIFICATION,
    SUBMIT_VERIFICATION_ERROR,
    SUBMIT_VERIFICATION_SUCCESS,
    VERIFY_AUTHENTICATOR_CODE,
    VERIFY_AUTHENTICATOR_CODE_ERROR,
    VERIFY_AUTHENTICATOR_CODE_SUCCESS,
    AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS,
    GET_ACCOUNT_RECOVERY,
    GET_ACCOUNT_RECOVERY_SUCCESS,
    GET_ACCOUNT_RECOVERY_ERROR,
    ACCOUNT_RECOVERY_SELECTION,
    SETUP_RECOVERY_PHONE,
    SETUP_RECOVERY_PHONE_SUCCESS,
    SETUP_RECOVERY_PHONE_ERROR } from '../constants/registration'
import ResendCodeTypes from '../constants/resend-code'
import SendChallengeStatus from '../constants/send-challenge'
import SubmitVerificationTypes from '../constants/verification'
import SubmitVerifyAuthenticatorCodeTypes from '../constants/verify-authenticator-code'
import resendMessage from '../constants/resend-message'
import FetchAccountRecovery from '../constants/fetch-account-recovery'


export const initialState = {
    accountRecoveryData: [],
    accountRecoveryStatus: FetchAccountRecovery.DEFAULT,
    activeSession: false,
    data: {},
    errorToken: null,
    mfaRequired: false,
    resendSuccessMsg: resendMessage.DEFAULT,
    sessionTimeout: false,
}

// Selectors
const selectRequestData = state => state.registration

const selectStateFor = key => createSelector(
    selectRequestData,
    (request = {}) => request[key]
)

export const selectActiveRegistrationSession = selectStateFor('activeSession')
export const selectAuthenticatorData = selectStateFor('authenticatorData')
export const selectAccountRecoveryData = selectStateFor('accountRecoveryData')
export const selectAccountRecoveryStatus = selectStateFor('accountRecoveryStatus')
export const selectErrorMessage = selectStateFor('error')
export const selectErrorTokenMessage = selectStateFor('errorToken')
export const selectData = selectStateFor('data')
export const selectQRCodeData = selectStateFor('qrCodeData')
export const selectStatus = selectStateFor('status')
export const selectStep = selectStateFor('step')
export const selectAuthenticatorStatus = selectStateFor('authenticatorStatus')
export const selectPasswordStatus = selectStateFor('passwordStatus')
export const selectQRCodeStatus = selectStateFor('qrCodeStatus')
export const selectResendCodeStatus = selectStateFor('resendCodeStatus')
export const selectRegistrationSessionTimeout = selectStateFor('sessionTimeout')
export const selectVerificationStatus = selectStateFor('verificationStatus')
export const selectVerifyAuthenticatorStatus = selectStateFor('verifyAuthenticatorCodeStatus')
export const selectUserAppsData = selectStateFor('userAppsData')
export const selectUserAppStatus = selectStateFor('userAppsStatus')
export const selectSendChallengeData = selectStateFor('sendChallengeData')
export const selectSendChallengeStatus = selectStateFor('sendChallengeStatus')
export const selectResendSuccessMsg = selectStateFor('resendSuccessMsg')
export const selectMfaRequired = selectStateFor('mfaRequired')
export const selectSetupRecoveryPhoneStatus = selectStateFor('setupRecoveryPhoneStatus')
export const selectSetupRecoveryPhoneError = selectStateFor('setupRecoveryPhoneError')


export default function registration(state = initialState, action) {
    switch (action.type) {

        case FETCH_DATA_ERROR:
            return {
                ...state,
                activeSession: false,
                data: {},
                errorToken: action.payload,
                status: Fetch.ERROR
            }
        case FETCH_DATA_SUCCESS:
            return {
                ...state,
                activeSession: true,
                data: { ...action.payload },
                errorToken: null,
                status: Fetch.SUCCESS,
                step: 1
            }
        case INIT:
            return {
                ...state,
                errorToken: null,
                status: Fetch.PENDING,
                step: 0
            }
        case INIT_AUTHENTICATORS:
            return {
                ...state,
                getMFAOptionsStatus: FetchAuthenticatorStatus.PENDING
            }
        case ENROLL_MFA:
            return {
                ...state,
                authenticatorStatus: FetchAuthenticatorStatus.PENDING,
                error: null
            }
        case INIT_AUTHENTICATORS_SUCCESS:
            return {
                ...state,
                getMFAOptionsStatus: FetchAuthenticatorStatus.SUCCESS,
                mfaRequired: action.payload?.mfaRequired || false
            }
        case ENROLL_MFA_SUCCESS:
            return {
                ...state,
                authenticatorData: { ...action.payload.authenticators || action.payload },
                authenticatorStatus: FetchAuthenticatorStatus.SUCCESS,
                error: null
            }
        case INIT_AUTHENTICATORS_ERROR:
        case ENROLL_MFA_ERROR:
            return {
                ...state,
                authenticatorStatus: FetchAuthenticatorStatus.ERROR,
                error: action.payload
            }
        case INIT_ENROLL_FACTOR:
            return {
                ...state,
                qrCodeStatus: QRCodeStatus.PENDING
            }
        case INIT_ENROLL_FACTOR_ERROR:
            return {
                ...state,
                error: action.payload,
                qrCodeStatus: QRCodeStatus.ERROR
            }
        case INIT_ENROLL_FACTOR_SUCCESS:
            return {
                ...state,
                qrCodeData: { ...action.payload },
                qrCodeStatus: QRCodeStatus.SUCCESS
            }
        case INIT_USER_APPS:
            return {
                ...state,
                userAppsStatus: FetchUserAppsStatus.PENDING
            }
        case INIT_USER_APPS_SUCCESS:
            return {
                ...state,
                userAppsData: { ...action.payload },
                userAppsStatus: FetchUserAppsStatus.SUCCESS
            }
        case INIT_USER_APPS_ERROR:
            return {
                ...state,
                error: action.payload,
                userAppsStatus: FetchUserAppsStatus.ERROR
            }
        case INIT_SEND_CHALLENGE:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeStatus: SendChallengeStatus.PENDING
            }
        case INIT_SEND_CHALLENGE_SUCCESS:
            return {
                ...state,
                error: null,
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeData: { ...action.payload },
                sendChallengeStatus: SendChallengeStatus.SUCCESS
            }
        case INIT_SEND_CHALLENGE_ERROR:
            return {
                ...state,
                error: action.payload,
                resendSuccessMsg: resendMessage.DEFAULT,
                sendChallengeStatus: SendChallengeStatus.ERROR
            }
        case ON_BACK:
            return {
                ...state,
                setupRecoveryPhoneStatus: null,
                step: (state && state.step ? state.step - 1 : 0)
            }
        case ON_BACK_TWO_STEPS:
            return {
                ...state,
                step: (state && state.step >= 2 ? state.step - 2 : 0)
            }
        case ON_NEXT:
            return {
                ...state,
                step: (state && state.step ? state.step + 1 : 0)
            }    
        case ON_BACK_AUTHENTICATORS:
            return {
                ...state,
                step: 4
            }
        case ON_FINISH:
            return {
                ...state,
                step: 9
            }
        case ON_WELCOME_NEXT:
            return {
                ...state,
                step: 1
            }
        case QR_CODE_NEXT:
            return {
                ...state,
                step: 8
            }
        case QR_CODE_CANNOT_SCAN:
            return {
                ...state,
                step: 7
            }
        case QR_CODE_CANNOT_SCAN_NEXT:
            return {
                ...state,
                step: 8
            }
        case RESEND_CODE:
            return {
                ...state,
                error: null,
                resendCodeStatus: ResendCodeTypes.PENDING,
                resendSuccessMsg: resendMessage.DEFAULT,
            }
        case RESEND_CODE_ERROR:
            return {
                ...state,
                error: action.payload,
                resendCodeStatus: ResendCodeTypes.ERROR,
                resendSuccessMsg: resendMessage.DEFAULT,
            }
        case RESEND_CODE_SUCCESS:
            return {
                ...state,
                error: null,
                resendCodeStatus: ResendCodeTypes.SUCCESS,
                resendSuccessMsg: resendMessage.SUCCESS,
                verificationStatus: '',
            }
        case SET_AUTHENTICATOR:
            return {
                ...state,
                step: 5
            }
        case SET_DEVICE_TYPE:
            return {
                ...state,
                step: 6
            }
        case SUBMIT_PASSWORD:
            return {
                ...state,
                error: null,
                passwordStatus: SubmitPasswordTypes.PENDING
            }
        case SUBMIT_PASSWORD_ERROR:
            return {
                ...state,
                error: action.payload,
                passwordStatus: SubmitPasswordTypes.ERROR
            }
        case SUBMIT_PASSWORD_SUCCESS:
            return {
                ...state,
                data: { ...action.payload },
                error: null,
                passwordStatus: SubmitPasswordTypes.SUCCESS,
                step: 4
            }
        case SUBMIT_VERIFICATION:
            return {
                ...state,
                error: null,
                verificationStatus: SubmitVerificationTypes.PENDING
            }
        case SUBMIT_VERIFICATION_ERROR:
            return {
                ...state,
                error: action.payload,
                verificationStatus: SubmitVerificationTypes.ERROR
            }
        case SUBMIT_VERIFICATION_SUCCESS:
            return {
                ...state,
                data: { ...action.payload },
                error: null,
                verificationStatus: SubmitVerificationTypes.SUCCESS
            }
        case VERIFY_AUTHENTICATOR_CODE:
            return {
                ...state,
                error: null,
                verifyAuthenticatorCodeStatus: SubmitVerifyAuthenticatorCodeTypes.PENDING
            }
        case VERIFY_AUTHENTICATOR_CODE_ERROR:
            return {
                ...state,
                error: action.payload,
                verifyAuthenticatorCodeStatus: SubmitVerifyAuthenticatorCodeTypes.ERROR
            }
        case VERIFY_AUTHENTICATOR_CODE_SUCCESS:
            return {
                ...state,
                authenticatorData:{},
                error: null,                
                verifyAuthenticatorCodeStatus: SubmitVerifyAuthenticatorCodeTypes.SUCCESS
            }
        case AFTER_VERIFY_AUTHENTICATOR_CODE_SUCCESS:
            return {
                ...state,
                step: 4,
                verifyAuthenticatorCodeStatus:null,
            }
        case SESSION_TIMEOUT: {
            return {
                ...state,
                sessionTimeout: true
            }
        }
        case GET_ACCOUNT_RECOVERY:
            return {
                ...state,
                accountRecoveryData: [],
                accountRecoveryStatus: FetchAccountRecovery.PENDING,
            }
        case GET_ACCOUNT_RECOVERY_SUCCESS:
            return {
                ...state,
                accountRecoveryData: action.payload,
                accountRecoveryStatus: FetchAccountRecovery.SUCCESS,
            }
        case GET_ACCOUNT_RECOVERY_ERROR:
            return {
                ...state,
                accountRecoveryData: [],
                accountRecoveryStatus: FetchAccountRecovery.ERROR,
            }
        case ACCOUNT_RECOVERY_SELECTION:
            return {
                ...state,
                step: 2
            }
        case SETUP_RECOVERY_PHONE:
            return {
                ...state,
                setupRecoveryPhoneStatus: 'PENDING',
                setupRecoveryPhoneError: null
            }
        case SETUP_RECOVERY_PHONE_SUCCESS:
            return {
                ...state,
                setupRecoveryPhoneStatus: 'SUCCESS',
                setupRecoveryPhoneError: null,
                step: 2
            }
        case SETUP_RECOVERY_PHONE_ERROR:
            return {
                ...state,
                setupRecoveryPhoneStatus: 'ERROR',
                setupRecoveryPhoneError: action.payload
            }
        default:
            return state
    }
}
